import { ListGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import keycloakService from "../../modules";

function WithoutDigilockerConsent(props) {
    const { showWithoutDigilocker , setShowWithoutDigilocker ,showProfile , setShowProfile } = props
    
    const handleClose = () => {
        // window.location.href = kycUrl
        setShowWithoutDigilocker(false)
        setShowProfile(true)
    }

    return (
        <>
            <Modal show={showWithoutDigilocker} onHide={() => keycloakService.doLogout()} animation={false}>
                {/* <OverlayTrigger
                    placement="right"
                    overlay={
                        <Tooltip id="logout-tooltip">
                            Clicking this button will log you out.
                        </Tooltip>
                    }
                >
                <Modal.Header closeButton>
                    <Modal.Title>Declaration 
                            <span
                                style={{
                                    fontSize: "0.90rem",
                                    color: "#6c757d",
                                    fontWeight: 500,
                                    paddingLeft:'8px'
                                }}
                            >
                                (Non Aadhaar-Authentication)
                            </span>
                    </Modal.Title>
                </Modal.Header>
                </OverlayTrigger> */}
                <Modal.Header closeButton className="border-0 pb-0">
                    <Modal.Title className="fw-bold fs-5 d-flex align-items-center gap-2">
                        Declaration 
                            <span
                                style={{
                                    fontSize: "0.90rem",
                                    color: "#6c757d",
                                    fontWeight: 500,
                                    paddingLeft:'8px'
                                }}
                            >
                                (Non Aadhaar-Authentication)
                            </span> 
                            <OverlayTrigger
                                placement="bottom"
                                trigger={["hover", "focus"]}
                                overlay={
                                    <Tooltip id="logout-tooltip">
                                        Clicking this button will log you out.
                                    </Tooltip>
                                }
                            >
                                <span
                                    style={{
                                        cursor: "pointer",
                                        color: "#0f4f96",
                                        fontSize: "16px"
                                    }}
                                >
                                </span> 
                            </OverlayTrigger>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    I hereby acknowledge, I want to proceed without aadhaar authentication.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        Agree and Continue
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default WithoutDigilockerConsent;